import { Locale } from "src/lib/Intl";

const getHowWeRateLink = (locale: Locale): string => {
  switch (locale) {
    case "it-it":
      return "/blog/marchi-di-moda-consapevoli-su-otrium";
    case "es-es":
      return "/blog/marcas-de-moda-que-otrium";
    case "nl":
      return "/blog/duurzame-merken-bij-otrium";
    case "nl-be":
      return "/blog/duurzame-merken-bij-otrium";
    case "pl-pl":
      return "/blog/marki-uznawane-za-swiadome-w-otrium";
    case "fr":
      return "/blog/les-marques-conscientes-sur-otrium";
    case "de":
      return "/blog/als-umweltbewusst-bewertete-marken-bei-otrium";
    case "en-us":
    case "en-gb":
    case "en":
    default:
      return "/blog/conscious-rated-fashion-brands-on-otrium";
  }
};

export { getHowWeRateLink };
